import Page from "components/common/page/Page";
import AgricultureMaintenanceTypeFormInputs from "components/entities/agriculture/work/maintenances/types/AgricultureMaintenanceTypeFormInputs";
import { useParams } from "react-router-dom";
import useAppNavigation from "utilities/hooks/useAppNavigate";

const AgricultureMaintenanceTypeFormPage = () => {
    const params = useParams<{id: string}>();
    const navigate = useAppNavigation();
    var id = Number(params.id) || undefined;


    return (
        <Page title="pages.agriculture.work.maintenance.type.form">
            <AgricultureMaintenanceTypeFormInputs 
            model={id}
            name="page"
            onSubmit={() => navigate(-1)} />
        </Page>
    );
};

export default AgricultureMaintenanceTypeFormPage;
